import React from 'react';
import {
  type CustomerDownloadAgreement,
  BATCH_DOWNLOAD_OPTION_TYPE,
} from 'types/isomorphic/download.types';
import EasyAccessCompMessage from '../EasyAccessCompMessage/EasyAccessCompMessage';
import PaOverageMessage from '../PaOverageMessage/PaOverageMessage';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex';
import useOnLoad from '../../../../hooks/queries/useOnLoad';
import { getIsMultiPaBulkDownloadActive } from '../../../../shared/multiPaBulkDownload';
import styles from '../Messages.module.scss';

interface DownloadMessageProps {
  isAgencyUnlimitedPilot?: boolean;
}

interface OptionWithOverage {
  type?: string;
  overageReached?: boolean;
}

const DownloadMessage: React.FC<DownloadMessageProps> = ({
  isAgencyUnlimitedPilot = false,
}) => {
  const { selectedOption } = useSelectedIndex();
  const {
    response: {
      config: {
        batchAgreements,
        ezaCompUser,
        availablePremiumAccessAgreements,
      } = {},
    } = {},
  } = useOnLoad();
  const batchEasyAccessOption =
    selectedOption?.type === BATCH_DOWNLOAD_OPTION_TYPE &&
    (batchAgreements as CustomerDownloadAgreement[] | undefined)?.some(
      (agreement) => agreement.productType === 'EasyAccess'
    );

  const multiPaBulkDownloadActive = getIsMultiPaBulkDownloadActive(
    availablePremiumAccessAgreements
  );
  const overageReachedOption =
    (selectedOption as OptionWithOverage)?.overageReached ||
    (selectedOption?.type === BATCH_DOWNLOAD_OPTION_TYPE &&
      !multiPaBulkDownloadActive &&
      (batchAgreements as CustomerDownloadAgreement[] | undefined)?.some(
        (agreement) => agreement.overageReached === true
      ));

  const renderDownloadMessage = () => {
    if (
      (selectedOption?.type === 'EasyAccess' && ezaCompUser) ||
      batchEasyAccessOption
    ) {
      return (
        <EasyAccessCompMessage
          isAgencyUnlimitedPilot={isAgencyUnlimitedPilot}
        />
      );
    }
    if (overageReachedOption) {
      return <PaOverageMessage />;
    }
    return null;
  };

  if (!selectedOption) {
    return null;
  }

  return (
    <section
      className={styles.messages}
      data-testid="download-message-container"
    >
      {renderDownloadMessage()}
    </section>
  );
};

export default DownloadMessage;
